import { Route, Routes } from 'react-router-dom';
import ROUTES from 'constants/route';
import SignInView from 'pages/sign-in/components';
import ResetPasswordView from 'pages/reset-password/components';
import ResetTempPasswordView from 'pages/reset-temp-password/components';
import ForgotPasswordView from 'pages/forgot-password/components';
import AuthWrapper from 'base/auth/components';
import DashboardView from 'pages/dashboard/components';
import ProfileBase from 'pages/profile';
import SessionsBase from 'pages/sessions';
import SchedulesView from 'pages/schedules';
import FormsBase from 'pages/forms';
import UsersBase from 'pages/users';
import DigitalCoachingTool from 'pages/sessions/components/digital-coaching-tool';
import NotAvailable from 'pages/not-available';
import MediaLibrary from '../pages/media-library';
import GroupsBase from '../pages/groups';
import ArticlesBase from '../pages/articles';
import NewsFeed from '../pages/newsfeed';
import wallet from '../pages/wallet';
import Review from '../pages/review';

// @TODO: This approach is good. But the issue when public routes are increase then array
// will be growing. Another thing is you have used 4 lines to stop the duplication of "Route".
const routers = [
  {
    path: ROUTES.LOGIN,
    component: SignInView,
  },
  {
    path: ROUTES.RESET_PASSWORD,
    component: ResetPasswordView,
  },
  {
    path: ROUTES.RESET_TEMP_PASSWORD,
    component: ResetTempPasswordView,
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    component: ForgotPasswordView,
  },
  {
    path: ROUTES.NOT_FOUND,
    component: () => (
      <div className="d-flex align-items-center justify-content-center flex-column vh-100 vw-100">
        <h1 style={{ color: 'gray', marginBottom: -20 }}>Sorry</h1>
        <h2 style={{ color: 'gray', padding: '40px' }}>Tenant URL is invalid</h2>
      </div>
    ),
  },
  {
    path: ROUTES.NOT_ACTIVE,
    component: () => (
      <div className="d-flex align-items-center justify-content-center flex-column vh-100 vw-100">
        <h1 style={{ color: 'gray', marginBottom: -20 }}>Sorry</h1>
        <h2 style={{ color: 'gray', padding: '40px' }}>This tenant is currently inactive</h2>
      </div>
    ),
  },
  {
    path: ROUTES.HEALTH,
    component: () => <p>App Health ok</p>,
  },
  {
    path: ROUTES.NOT_AVAILABLE,
    component: NotAvailable,
  },
];

const protectedRouters = [
  {
    path: ROUTES.DASHBOARD,
    component: DashboardView,
  },
  {
    path: ROUTES.PROFILE,
    component: ProfileBase,
  },
  {
    path: ROUTES.SCHEDULES,
    component: SchedulesView,
  },
  {
    path: ROUTES.SESSIONS,
    component: SessionsBase,
  },
  {
    path: ROUTES.MEDIA_LIBRARY,
    component: MediaLibrary,
  },
  {
    path: ROUTES.MEDIA_LIBRARY_RECORD_CONTENT,
    component: DigitalCoachingTool,
  },
  {
    path: ROUTES.GROUPS,
    component: GroupsBase,
  },
  {
    path: ROUTES.USERS,
    component: UsersBase,
  },
  {
    path: ROUTES.ARTICLES,
    component: ArticlesBase,
  },
  {
    path: ROUTES.FORMS,
    component: FormsBase,
  },
  {
    path: ROUTES.NEWSFEED,
    component: NewsFeed,
  },
  {
    path: ROUTES.WALLET,
    component: wallet,
  },
  {
    path: ROUTES.REVIEW,
    component: Review,
  },
];

const Router = () => (
  <Routes>
    {routers.map((route) => (
      <Route element={<route.component />} key={route.path} path={route.path} />
    ))}
    {protectedRouters.map((route) => (
      <Route
        element={<AuthWrapper><route.component /></AuthWrapper>}
        key={route.path}
        path={route.path}
      />
    ))}
  </Routes>
);

export default Router;
